import axios from "fetch-api/fetch-api";

// Subscription Modal
export default function showSubscriptionModalApi() {
  return axios.post<boolean>("/is-newsletter-subscription-needed"); // return: true or false
}
